import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/ui/Button'
import {
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle
} from '@/shared/ui/Dialog'

import { OfferForShowPrice } from '../types/OfferForShowPrice'
import { OfferPriceContent } from './OfferPriceContent'

interface PriceDialogContentProps {
	offer: OfferForShowPrice
	onClose: () => void
}

export const PriceDialogContent = ({
	onClose,
	offer
}: PriceDialogContentProps) => {
	const { t } = useTranslation('price')

	return (
		<DialogContent className="px-5 max-sm:pb-40 xl:hidden">
			<DialogHeader>
				<DialogTitle className="ts-headline-2">{t('modal.title')}</DialogTitle>
			</DialogHeader>

			<OfferPriceContent offer={offer} />

			<DialogFooter className="flex justify-center">
				<Button
					className="w-40"
					variant="default"
					onClick={onClose}
				>
					{t('close', { ns: 'translation' })}
				</Button>
			</DialogFooter>
		</DialogContent>
	)
}
